import React, { Component } from 'react'
import styled from 'styled-components'
import logo from './bg.png'
import { ConfigurationState } from '../../../ducks/references/types'
import { AppState, Dispatch } from 'store/types'
import { bindActionCreators } from 'redux'
import { createAccount } from '../../../ducks/auth/operations'
import {
  fetchConfigurationLogo,
  fetchConfiguration
} from '../../../ducks/references/operations'
import { connect } from 'react-redux'

interface State {
  configuration: ConfigurationState
  configurationLogo: string
}

class LogoTip extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      configuration: {
        isFetching: false,
        data: {
          appointmentTypeSearchEnabled: false,
          defaultEstimationDropdownType: 'cpt4',
          estimatorHost: '',
          fakeEligibility: true,
          inPatientEnable: true,
          logoEnabled: true,
          outComplexEnable: true,
          outPatientEnable: true,
          physicianFieldEnabled: true,
          procedureCodeEnabled: true,
          serviceAreaFieldEnabled: true
        }
      },
      configurationLogo: ''
    }
  }
  componentDidMount(): void {
    const {
      isFetching,
      isFetchingLogo
    } = this.props
    // console.log(!isFetchingLoggedIn, !isFetchingRegistration, !isFetchingLogo, !isFetching, !isFetchingLoggedIn && !isFetchingRegistration && !isFetchingLogo && !isFetching)
    if (!isFetching) {
        this.props.fetchConfiguration()
        this.props.fetchConfigurationLogo()
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (
      prevProps.configuration.data.logoEnabled !==
      this.props.configuration.data.logoEnabled
    ) {
      this.setState({ configuration: { ...this.props.configuration } })
    }
    if (
      prevProps.configurationLogo !== this.props.configurationLogo ||
      this.props.configurationLogo !== this.state.configurationLogo
    ) {
      this.setState({ configurationLogo: this.props.configurationLogo })
    }
  }

  render() {
    const { configuration, configurationLogo } = this.state
    // return <LogoTipComp isShowLogo={configuration.data.logoEnabled} />
    return configurationLogo && configuration.data.logoEnabled ? (
      <Image src={configurationLogo} />
    ) : (
      <LogoTipComp isShowLogo={false} />
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  configuration: state.references.configuration,
  isFetching: state.references.configuration.isFetching,
  isFetchingLogo: state.references.configurationLogo.isFetching,
  isFetchingRegistration: state.auth.isFetchingRegistration,
  isFetchingLoggedIn: state.auth.isFetchingLoggedIn,
  configurationLogo: state.references.configurationLogo.content
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { createAccount, fetchConfiguration, fetchConfigurationLogo},
    dispatch
  )

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps

interface LogoTipProps {
  isShowLogo: boolean
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogoTip)
// export default MainPage

const LogoTipComp = styled.div<LogoTipProps>`
  background: ${props =>
    props.isShowLogo ? `url(${logo})` : undefined};//url(${logo});
  background-size: cover;
  width: 144px;
  height: 50px;
  margin-bottom: 3rem;
`
const Image = styled.img`
  max-width: 200px;
  max-height: 150px;
  width: auto;
  height: auto;
  object-fit: contain;
  margin-bottom: 3rem;
`
